export default function Home() {
  return (
    <div 
      className="min-h-screen bg-cover bg-center text-gray-800 flex flex-col"
      style={{ backgroundImage: "url('/background50.jpg')" }}
    >

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="bg-white bg-opacity-90 shadow-xl rounded-2xl p-8 max-w-md w-full text-center">
          <h1 className="text-2xl font-bold text-olive mb-4">
            Still Decomposing...
          </h1>
          <p className="mb-4">
            🌱 Our site is composting in progress. Come back soon to see what grows!
          </p>
          <p className="text-sm text-sienna mb-6">
            In the meantime, stay grounded and keep turning those scraps into soil.
          </p>

          {/* Email Notify Form (non-functional placeholder) */}
          <form
            action="https://formspree.io/f/mqaqobwe"
            method="POST"
            className="flex flex-col gap-2"
          >
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
            />
            <button
              type="submit"
              className="bg-blue text-white px-4 py-2 rounded-md hover:bg-olive"
            >
              Keep Up to Date!
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
